

export default function OrContainer(){
    return <div className="flex justify-between w-full items-center  gap-2 pt-6">
    <div className="h-c1 w-full bg-gray-300 "></div>
    <span className="text-xs color222">or</span>
    <div className="h-c1 w-full bg-gray-300"></div>
  </div>
}